import { render, staticRenderFns } from "./SelectNumberOfChildrenChairs.vue?vue&type=template&id=72b30ffe"
import script from "./SelectNumberOfChildrenChairs.vue?vue&type=script&lang=js"
export * from "./SelectNumberOfChildrenChairs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports